<div>
    <app-amc-renewal-form></app-amc-renewal-form>
</div>

<div>
    <app-amc-renewal-list></app-amc-renewal-list>
</div>